var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-series-chart"},[_c('VueApexCharts',{attrs:{"type":"area","height":"380","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }